import { Type } from "@sinclair/typebox";

//#region src/shared/bricks/props/tags.ts
function tags(options) {
	return Type.Array(Type.String({
		title: options?.title ?? "Tags",
		...options
	}), {
		"ui:field": "tags",
		title: options?.title ?? "Tags",
		metadata: { category: "content" },
		...options
	});
}

//#endregion
export { tags };
//# sourceMappingURL=tags.js.map